import { queryKeys } from './queryKeys';

/** Refresh all caches that read Paramètres (org info, logo, commission, etc.). */
export async function invalidateSettingsGraph(queryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.settings.organization }),
    queryClient.invalidateQueries({ queryKey: queryKeys.benefits.dashboard }),
    queryClient.invalidateQueries({ queryKey: queryKeys.reports.source }),
    // Legacy keys still referenced in some components
    queryClient.invalidateQueries({ queryKey: ['settings'] }),
    queryClient.invalidateQueries({ queryKey: ['organizationSettings'] }),
  ]);
}
